/*
  Implements a cached state storage using the browser's sessionStorage
  Can be used when we need to store anything that should be tab-scoped
  It will survive browser tab refreshes, but is destroyed upon tab closure.
  @todo Research exceptions on sessionStorage API
*/

const persistedState: Record<string, string> = {};

const getItem = (key: string): string | null => {
  return persistedState[key] || sessionStorage.getItem(key);
};

const setItem = (key: string, value: string): void => {
  persistedState[key] = value;
  sessionStorage.setItem(key, value);
};

const removeItem = (key: string): void => {
  delete persistedState[key];
  sessionStorage.removeItem(key);
};

export { getItem, setItem, removeItem };
